import React from "react";
import { toast } from "sonner";
import { Moneybag, Phone } from "tabler-icons-react";

/**
 * Composant pour afficher les options de paramètres
 */
const SettingsCard = ({ onNavigate }) => {
  const handleAbonnementClick = () => {
    toast.info("Cette fonctionnalité sera disponible prochainement 🚀", {
      duration: 5000,
    });
  };

  const settingsOptions = [
    {
      label: "Contacter Genimi",
      path: "/contact-genimi",
      action: "navigate",
      icon: <Phone />
    },
    {
      label: "Gérer mon abonnement",
      path: "/abonnement",
      action: "toast",
      icon: <Moneybag />
    },
  ];

  const handleOptionClick = (option) => {
    if (option.action === "toast") {
      handleAbonnementClick();
    } else {
      onNavigate(option.path);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md py-6">
      <h3 className="text-lg font-semibold text-gray-700 mb-4 px-6">
        Paramètres du compte
      </h3>

      {settingsOptions.map((option, index) => (
        <button
          key={option.path}
          onClick={() => handleOptionClick(option)}
          className={`w-full py-3 ${
            index < settingsOptions.length - 1 ? "mb-3 border-b border-gray-300" : ""
          } bg-white text-gray-700 hover:bg-gray-20 transition flex items-center justify-between px-6 `}
        >
          <div className="inline-flex justify-center gap-3">
            <span className="">{option?.icon}</span>
            <span>{option.label}</span>
          </div>
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      ))}
    </div>
  );
};

export default SettingsCard;
